import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { updateFeedbackType } from '../api/feedbackTypes.api';
import type { UpdateFeedbackTypePayload } from '../types/feedbackType.types';

export function useUpdateFeedbackType(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: UpdateFeedbackTypePayload }) =>
      updateFeedbackType(id, payload),
    onSuccess: () => {
      void refreshRelatedData('feedbackType');
      toast.success('Feedback type updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update feedback type');
    },
  });
}
